<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <approved-bill-line-control></approved-bill-line-control>
      <approved-bill-line-view></approved-bill-line-view>
    </v-layout>
  </v-container>
</template>


<script>
import ApprovedBillLineControl from '@/modules/approvedBillLines/approvedBillLineControl'
import ApprovedBillLineView from '@/modules/approvedBillLines/approvedBillLineView'

export default {
  components: {
    ApprovedBillLineControl,
    ApprovedBillLineView
  }
}
</script>

<style>
</style>
